/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_TitleInputs */

const en_mk_tut_title = /** @type {(inputs: Mk_Tut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need, in order`)
};

const id_mk_tut_title = /** @type {(inputs: Mk_Tut_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua yang perlu Anda tahu, berurutan`)
};

/**
* | output |
* | --- |
* | "Everything you need, in order" |
*
* @param {Mk_Tut_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_title = /** @type {((inputs?: Mk_Tut_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_title(inputs)
	return en_mk_tut_title(inputs)
});